import { Loader } from "%helpers";

export default {
  components: { Loader },

  data() {
    return {
      actions: {}
    };
  },

  computed: {
    actionsValues() {
      return Object.values(this.actions);
    },

    actionsLoaded() {
      return Object.entries(this.actions).length > 0 && this.allActions("ok");
    }
  },

  methods: {
    dispatchWithProgress(name, action, params) {
      this.$set(this.actions, name, "loading");

      return this.$store
        .dispatch(action, params)
        .then(response => {
          this.$set(this.actions, name, "ok");
          return response;
        })
        .catch(error => {
          this.$set(this.actions, name, "error");
          throw error;
        });
    },

    allActions(key) {
      return this.actionsValues.filter(x => x !== key).length === 0;
    },

    anyAction(key) {
      return this.actionsValues.filter(x => x === key).length > 0;
    },

    isActionOk(key) {
      return this.actions[key] === "ok";
    },

    isActionLoading(key) {
      return this.actions[key] === "loading";
    },

    isActionError(key) {
      return this.actions[key] === "error";
    }
  }
};
